export type { PanelProps } from '@/components/composite/GeoMap/panels/panel.types';

export enum PanelType {
  Dashboard = 'Dashboard',
  IncidentsFeed = 'IncidentsFeed',
  Filters = 'Filters',
  MapView = 'MapView',
}
